import React from 'react';
interface CTAButtonProps {
  text: string;
  subtext?: string;
  href?: string;
  id?: string;
  className?: string;
}
export function CTAButton({
  text,
  subtext,
  href = '#compra',
  id,
  className = ''
}: CTAButtonProps) {
  return <a href={href} id={id} className={`group relative inline-flex flex-col items-center justify-center w-full max-w-2xl px-8 py-6 text-center text-white bg-gradient-to-b from-green-400 to-green-700 rounded-xl shadow-[0_8px_0_rgb(21,128,61),0_15px_20px_rgba(0,0,0,0.4)] hover:shadow-[0_4px_0_rgb(21,128,61),0_8px_10px_rgba(0,0,0,0.4)] hover:translate-y-1 transition-all duration-200 active:shadow-[0_0px_0_rgb(21,128,61),0_0px_0px_rgba(0,0,0,0.4)] active:translate-y-2 animate-pulse hover:animate-none ${className}`} data-id="element-61">
      <span className="text-2xl md:text-4xl font-black uppercase tracking-wide drop-shadow-md" data-id="element-62">
        {text}
      </span>
      {subtext && <span className="mt-2 text-sm md:text-lg font-bold text-green-100 drop-shadow-sm" data-id="element-63">
          {subtext}
        </span>}

      {/* Shine effect */}
      <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-20 group-hover:animate-[shine_1s_ease-in-out]" data-id="element-64" />
    </a>;
}